import { on } from '@ember/modifier';
import { guidFor } from '@ember/object/internals';
import Component from '@glimmer/component';

interface WorkflowReevaluationWarningSignature {
  Args: {
    isDenied?: boolean;
    reason: string;
    onReasonInput: (event: Event) => void;
  };
}

// Shared body (heading + copy + reason textarea) for the re-approval warning, so the one-off
// WorkflowReevaluationModal and the folded recurring edit modal can't drift in copy.
export default class WorkflowReevaluationWarning extends Component<WorkflowReevaluationWarningSignature> {
  // Instance-unique so the label's `for` stays correct if two warnings ever co-mount.
  reasonId = `workflow-reevaluation-reason-${guidFor(this)}`;

  <template>
    {{#if @isDenied}}
      <h2 class="text-2xl mb-4">Resubmit this invite for approval</h2>
      <p class="text-carbon-60 mb-6">
        Saving these changes will
        <strong>resubmit this invite for approval</strong>. The approval route may change based on the updated details.
      </p>
    {{else}}
      <h2 class="text-2xl mb-4">You're editing an approved record</h2>
      <p class="text-carbon-60 mb-6">
        Saving these changes will
        <strong>cancel the existing approval</strong>
        and start a new process. The approval route may change based on the updated details.
      </p>
    {{/if}}
    <div class="mb-6">
      <label for={{this.reasonId}} class="block mb-2 text-carbon-60">
        Reason for this change
        <span class="text-carbon-50">(optional)</span>
      </label>
      <textarea
        id={{this.reasonId}}
        data-test-workflow-reevaluation-reason
        class="w-full p-3 border border-carbon-20 rounded resize-none"
        rows="4"
        placeholder="e.g. Schedule conflict"
        value={{@reason}}
        {{on "input" @onReasonInput}}
      ></textarea>
    </div>
  </template>
}
